import { lazyWithSuspense } from '~/utilities/lazyWithSuspense';
import { LoadingState } from './LoadingState';

export const MediaReview = lazyWithSuspense(async () => import('./MediaReviewScreen'), {
  loadingState: <LoadingState />,
});
